<template>
  <div class="badge-wrap badge-wrap-card">
    <canvas id="confetti-cards"></canvas>
    <div class="badge-content">
      <h4>
        {{
          $i18n.locale == 'it' ?
          "CONGRATULAZIONI"
          :
          "CONGRATULATIONS"
        }}
      </h4>
      <img src="../assets/badges/badge-do-your-part-eat-smart.png" />
      <p
        v-html="
        $i18n.locale == 'it' ?
        `Hai appena sbloccato un nuovo badge!<br>
        Controlla tutta la tua raccolta e scaricali dal menù!`
        :
        `You've just unlocked a new badge!<br>
        Check out your full collection and download them from the menu!`
       "
      >
      </p>
      <div class="cta-close" @click="closeOverlay">
        {{
          $i18n.locale == 'it' ?
          "Riscuoti il tuo badge"
          :
          "Collect your badge!"
        }}
      </div>
    </div>
  </div>
</template>

<script>

import {gsap} from 'gsap'
import Confetti from 'canvas-confetti'

export default {
  name: 'BadgeCards',
  props: ['start', 'isOverlay'],
  components:{
  },
  data(){
    return {
      myConfetti: null
    }
  },
  methods:{
    startTransition(){
      
      var TL = gsap.timeline()
      TL.to('.badge-wrap-card', {top: 0, onComplete: () => {
        
      }})

    },
    createConfetti(){
      let confettiEl = document.getElementById('confetti-cards')
      this.myConfetti = Confetti.create(confettiEl, {
        resize: true
      });
    },
    closeOverlay(){
      this.myConfetti({
        particleCount: 200,
        spread: 200,
        shapes: ['square', 'circle'],
        scalar: 2,
        colors: ['#3C4F9B', '#2E70E2', '#F0BEA8']
      });
      gsap.to('.badge-wrap-card', {delay: 1, top: '100%', onComplete: () => {
        gsap.set('.badges-wrap', {top: '100%'});
        this.$store.dispatch('selectBadge', 'cards')
        
        if(this.isOverlay){
          gsap.to('.cards-game-wrap', {duration: .75, left: '-100%', ease: 'Power2.easeInOut', 
            onComplete: () => {
              
              this.$store.dispatch('openOverlay', '')
              this.$store.dispatch('triggerReply');
              this.$store.dispatch('setMenuCtaVisibility',true);
            }
          })
        }else{
          gsap.fromTo('#menu', {x: '100%' }, {x: '0%', duration: .75, ease: 'Power2.easeInOut'})
        }
          
      }})
    }
  },
  mounted(){
    this.createConfetti()
  },
  computed:{
   
  },
  watch: {
    start(val){
      if(val === 'cards') this.startTransition()
    }
  }
}
</script>

<style lang="scss">
  .badge-wrap {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 100%;
    left: 0;
    display: flex;
    z-index: 9;
    align-items: center;
    justify-content: center;
    &.badge-wrap-card{
      background-color: rgba($color: #E86E36, $alpha: 0.95);
    }
    .badge-content{
      position: relative;
      margin: 0 auto;
      max-width: 60%;
      display: flex;
      flex-direction: column;
      text-align: center;
      z-index: 8;
      h4{
        font-size: 48px;
        margin-bottom: 40px;
        font-weight: 700;
      }
      img{
        max-width: 320px;
        margin:0 auto 32px;
        @media screen and (max-width: 768px) {
          max-width: 60%;
        }
      }
      p{
        font-size: 24px;
        line-height: 32px;
        font-weight: 400;
        margin-bottom: 40px;
      }
      .cta-close{
        background-color: #2E70E2;
        color: #fff;
        padding: 12px 40px;
        font-size: 24px;
        line-height: 32px;
        font-weight: 400;
        display: inline-block;
        border-radius: 5px;
        margin: 0 auto;
        cursor: pointer;
      }
      @media screen and (max-width: 768px) {
        max-width: 80%;
        h4{
          font-size: 30px;
        }
        .cta-close{
          font-size: 18px;
        }
      }
    }
  }
  #confetti-cards{
    position: absolute;
    top: 0;
    left: 50%;
    height: 100vh;
    width: 100vw;
    transform: translateX(-50%);
    z-index: 7;
  }
</style>